import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormControl,
  Select,
  MenuItem,
  makeStyles,
  InputLabel,
} from "@material-ui/core";
import {
  setPrimaryBu,
  selectProductgroup,
  getListofProductgroup,
  getListBuMappingMaster,
  set,
} from "./productgroupSlice";
import {
  clear as clrPrdType,
  setList as producttypeSetList,
} from "../producttype/producttypeSlice";
import styles from "./Productgroup.module.css";
import { selectLanguage } from "../language/languageSlice";
import { selectScgbu } from "../scgbu/scgbuSlice";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: "100%",
    "&:hover": {
      boxShadow: "0 1px 1.5px rgba(0,0,0,0.16), 0 1px 1.5px rgba(0,0,0,0.23)",
    },
    transition: "box-shadow 0.75s",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  textHilight: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
  },
}));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export function Productgroup() {
  const classes = useStyles();
  const currentProductgroup = useSelector(selectProductgroup);

  const listProd = useSelector(getListofProductgroup);
  const language = useSelector(selectLanguage);
  const scgbu = useSelector(selectScgbu);
  const BuMaster = useSelector(getListBuMappingMaster);
  const mainBu2PrdCatLv1 = [].concat(
    ...[
      ...listProd.map((prodgrp) => {
        let tmpPrd = JSON.parse(JSON.stringify(prodgrp.Th));
        tmpPrd["BussinessUnit"] = prodgrp.BussinessUnit;
        //console.log(tmpPrd);
        return tmpPrd;
      }),
    ].map((PrdGrp) => {
      let tmpPrd2 = JSON.parse(JSON.stringify(PrdGrp.Product));

      tmpPrd2.map(
        (p) =>
          (p["BussinessUnit"] = BuMaster.filter(
            (buinfo) => buinfo.Name === PrdGrp.BussinessUnit
          )[0].Id)
      );
      //console.log(tmpPrd2);
      return tmpPrd2;
    })
  );
  //console.log(mainBu2PrdCatLv1);
  let listOfProductgroup = [];

  if (listProd.length > 0) {
    if (language === "TH") {
      if (scgbu !== "default") {
        listOfProductgroup = [].concat(
          ...[
            ...listProd
              .filter((prod) => prod.BussinessUnit === scgbu)
              .map((prodgrp) => prodgrp.Th),
          ].map((PrdGrp) => PrdGrp.Product),
          ...[
            ...listProd
              .filter((prod) => prod.BussinessUnit !== scgbu)
              .map((prodgrp) => prodgrp.Th),
          ].map((PrdGrp) => PrdGrp.Product)
        );
      } else {
        listOfProductgroup = [].concat(
          ...[...listProd.map((prodgrp) => prodgrp.Th)].map(
            (PrdGrp) => PrdGrp.Product
          )
        );
      }
    } else {
      if (scgbu !== "default") {
        listOfProductgroup = [].concat(
          ...[
            ...listProd
              .filter((prod) => prod.BussinessUnit === scgbu)
              .map((prodgrp) => prodgrp.En),
          ].map((PrdGrp) => PrdGrp.Product),
          ...[
            ...listProd
              .filter((prod) => prod.BussinessUnit !== scgbu)
              .map((prodgrp) => prodgrp.En),
          ].map((PrdGrp) => PrdGrp.Product)
        );
      } else {
        //console.log(listOfProductgroup);
        listOfProductgroup = [].concat(
          ...[...listProd.map((prodgrp) => prodgrp.En)].map(
            (PrdGrp) => PrdGrp.Product
          )
        );
      }
    }
    //console.log(listOfProductgroup);
  }
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <FormControl className={classes.formControl} variant="outlined">
      <InputLabel id="productgroup-label">
        {" "}
        {language === "TH" ? "กลุ่มผลิตภัณฑ์" : "Product Group"}{" "}
      </InputLabel>{" "}
      <Select
        labelId="Producttype-input-label"
        id="Producttype-input"
        value={currentProductgroup}
        color="secondary"
        variant="outlined"
        onChange={(e) => {
          // console.log(
          //   ...[
          //     ...listOfProductgroup
          //       .filter((prdGrp) => prdGrp.id === e.target.value)
          //       .map((prdlst) => prdlst.Product),
          //   ]
          // );
          // console.log(mainBu2PrdCatLv1);
          console.log(
            mainBu2PrdCatLv1.filter((prdGrp) => prdGrp.id === e.target.value)
          );
          dispatch(clrPrdType());
          dispatch(
            setPrimaryBu(
              mainBu2PrdCatLv1.filter(
                (prdGrp) => prdGrp.id === e.target.value
              )[0].BussinessUnit
            )
          );
          dispatch(set(e.target.value));
          dispatch(
            producttypeSetList(
              ...[
                ...listOfProductgroup
                  .filter((prdGrp) => prdGrp.id === e.target.value)
                  .map((prdlst) => prdlst.Product),
              ]
            )
          );
        }}
        className={classes.selectEmpty}
      >
        <MenuItem value={currentProductgroup} className={classes.textHilight}>
          <em> None </em>{" "}
        </MenuItem>{" "}
        {listOfProductgroup.map((ProductGroup) => {
          // console.log(ProductGroup.id);
          return (
            <MenuItem
              key={ProductGroup.id}
              value={ProductGroup.id}
              className={classes.textHilight}
            >
              {" "}
              {ProductGroup.Name}{" "}
            </MenuItem>
          );
        })}{" "}
      </Select>{" "}
    </FormControl>
  );
}
